import React from "react";

export const RotateVertical = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>((props, ref) => {
	return (
		<svg
			ref={ref}
			width="220"
			height="220"
			viewBox="0 0 220 220"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M47.2852 68.2887C47.2758 69.6693 48.3875 70.7962 49.7681 70.8056C51.1488 70.815 52.2757 69.7034 52.2851 68.3227L47.2852 68.2887ZM52.2851 68.3227L52.3888 53.0863L47.3889 53.0522L47.2852 68.2887L52.2851 68.3227ZM61.9532 43.6511L86.2632 43.8165L86.2972 38.8166L61.9872 38.6512L61.9532 43.6511ZM52.3888 53.0863C52.4245 47.8397 56.7066 43.6154 61.9532 43.6511L61.9872 38.6512C53.9792 38.5967 47.4434 45.0443 47.3889 53.0522L52.3888 53.0863Z"
				fill="#0088E9"
			/>
			<path
				d="M75.0742 56.0696L89.0742 40.8583L75.0742 26.0696"
				stroke="#0088E9"
				strokeWidth="5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M178.504 36.3694L156.504 36.3694" stroke="black" strokeWidth="5" strokeLinecap="round" />
			<path d="M23 157V135" stroke="#A6A6A6" strokeWidth="5" strokeLinecap="round" />
			<path
				d="M127.752 197.69H97.3775H25.752C15.2585 197.69 6.75195 189.183 6.75195 178.69V114.69C6.75195 104.197 15.2585 95.6899 25.752 95.6899H97.3775H116.818"
				stroke="#A6A6A6"
				strokeWidth="5"
			/>
			<rect
				x="-2.5"
				y="2.5"
				width="97"
				height="177"
				rx="16.5"
				transform="matrix(-1 0 0 1 212.994 20.3677)"
				stroke="black"
				strokeWidth="5"
			/>
		</svg>
	);
});
RotateVertical.displayName = "RotateVertical";
